import { render } from "./RubiksCube.vue?vue&type=template&id=120b0b5a&scoped=true"
import script from "./RubiksCube.vue?vue&type=script&lang=js"
export * from "./RubiksCube.vue?vue&type=script&lang=js"

import "./RubiksCube.vue?vue&type=style&index=0&id=120b0b5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120b0b5a"]])

export default __exports__